module.exports = __webpack_public_path__ + "static/media/logo.18db08d6.svg";